export const URLS = {
  SIGN_IN: "sign-in",
  SIGN_UP: "sign-up",
  USER: "user",
  CREATE_EVENT: "create-event",
  GET_EVENTS: "get-events",
  CREATE_EMPLOYEE_GENERAL_INFO: "create-employee-general-info",
  GET_MASTER_DATA: "base-data",
  GET_ORGANIZATION_DATA: "organization",

  CREATE_EMPLOYEE_POSTINGS: "create-postings",
  GET_EMPLOYEE_POSTINGS: "get-postings",
  CREATE_EMPLOYEE_SERVICES: "create-services",
  GET_EMPLOYEE_SERVICES: "get-services",
  CREATE_EMPLOYEE_QUALIFICATIONS: "create-qualifications",
  GET_EMPLOYEE_QUALIFICATIONS: "get-qualifications",
  CREATE_EMPLOYEE_FAMILY: "create-employee-family",
  GET_EMPLOYEE_FAMILY: "get-employee-family",
  CREATE_EMPLOYEE_APR: "create-apr",
  EMPLOYEE_APR: "apr-info",
  CREATE_EMPLOYEE_DISCIPLINES: "create-employee-disciplines",
  UPDATE_EMPLOYEE_DISCIPLINES: "create-employee-disciplines",
  GET_EMPLOYEE_DISCIPLINES: "get-employee-disciplines",
  EMPLOYEES: "employees",
  EMPLOYEE: "employee",
  CREATE_EMPLOYEE_ACR: "create-acr",
  GET_EMPLOYEE_ACR: "get-acr",
  GET_EMPLOYEE_SUMMARY: "get-employee-summary",
  GET_RETIREMENT_LIST: "get-retirement-list",
  GET_PROMOTION_CANDIDATES: "get-promotion",
  CREATE_PROMOTION: "get-promotion/:id",
  GET_RETIREMENT: "get-retirement",
  CREATE_RETIREMENT: "create-retirement",
  RETIREMENTS: "retirements",
  PROMOTION: "promotion",
  PROMOTIONS: "promotions",
  ATTENDANCE: "attendance",
  GET_ATTENDANCE_SUMMARY: "attendance/summary-info",
  ACR: "acr",
  APR: "apr",
  UNIT_POSITIONS: "unit-positions",
  UNITS: "units",
  POSITIONS: "positions",
  PROVIDENT_FUNDS: "gpf-loans",
  CREATE_NEW_LOAN: "add-new-loan",
  PUNISHMENT: "discipline-infos",
  APR_LIST: "employee-list-for-apr",
  ACR_LIST: "employee-list-for-acr",
  DOCUMENTS_UPLOAD: "documents-upload",
  DOCUMENT_UPDATE: "document-update",
  DOCUMENTS_DELETE: "documents-delete",
  RESIGNATIONS: "resignations",
  LEAVE: "leave",
  TYPES: "types",
  DETAILS: "details",
  BALANCE: "balance",
  HISTORY_LIST: "historylist",
  START_WORKFLOW: "start-workflow",
  EXECUTE_WORKFLOW: "execute-workflow",
  SEND_FOR_APPROVAL: "send-for-approval",
  APPROVAL_ACTION: "approval-action",
  PROMOTION_DETAILS: "promotion-details",
  RECOMMENDATIONS: "recommendations",
  TRANSFERS: "transfers",
  EXCHANGE_TRANSFER: "exchange-transfers",
  REPORTS: "reports",
  UPDATE_USER_NAME: "update-username",
  RESET_PASSWORD: "reset-password",

  // tickets
  TICKETS: "tickets",
  MY_TICKET: "my-ticket",
  REQUESTED_TICKET: "requested-ticket",
  ASSIGNED_TICKET: "assigned-ticket",
  SETTINGS: "settings",
  TICKET_TYPES: "ticket-types",
  TICKET_CATEGORIES: "categories",
  TICKET_STATUS: "status",
  TICKET_PRIORITIES: "priorities",
  COMMENTS: "comments",
};
